/*
 * @Author: cc
 * @LastEditTime: 2022-06-17 17:21:06
 */
import { useEffect, useState } from "react";
// import { IsPc } from "../utils/index";
import Style from "./index.module.scss"
import "moment/locale/zh-cn";
import { useLocation, useHistory } from "react-router-dom";
// import type { PickerRef } from "antd-mobile/es/components/picker";
import { post } from "src/component/fetch"
import { encode } from 'js-base64';
import { Form, Input, Button, Tabs, Toast } from 'antd-mobile'
import store from "../../../reducers"
export const useQuery = () => {
    return new URLSearchParams(useLocation().search);
};

const Index = () => {
    const query = useQuery()
    const [randomImgUrl, setRandomImgUrl] = useState('')
    const history = useHistory();
    const subjectId = query.get('subjectId') || ''
    const [registerForm] = Form.useForm()
    const [activeKey,setActiveKey] = useState('login')
    //表单提交
    const onFinish = (val: any) => {
        let data = { ...val }
        data.mobile = encode(data.mobile)
        data.password = encode(data.password)
        data.verifyCode = encode(data.verifyCode)
        data.subjectId = encode(subjectId)
        post('/user/api/ge/user/login', data, true).then((res:any) => {
            if (res.code === 0) {
                post('/shop/front/ge/userInfo',{},false).then((result:any)=>{
                    store.dispatch({
                      type: "SET_USER_INFO",
                      ...result.data
                    })
                    Toast.show({
                        icon: 'success',
                        content: '登录成功',
                    })
                    history.goBack()
                  })
                // props.onCancel()
                // props.onOk()
            } else {
                Toast.show({
                    icon: 'error',
                    content: res.data.msg,
                })
            }
        })
    }
    /**获取图形验证码 */
    function getRandomImgFn() {
        let url = `/user/api/verify/code`;
        fetch(url)
            .then(
                (response) => {
                    return response.json();
                },
                (error) => console.log("An error occurred.", error)
            )
            .then((res) => {
                setRandomImgUrl(res.data);
            });
    }
    const registerFinish = (val: any) => {
        const { mobile, password, smsCode } = val
        post('/user/api/ge/user/register', {
            mobile: encode(mobile),
            password: encode(password),
            smsCode: encode(smsCode)
        }, true).then(res => {
            if (res.data.code === 0) {
                Toast.show({
                    icon: "success",
                    content: "注册成功"
                })
                setActiveKey('login')
            } else {
                Toast.show({
                    icon: "error",
                    content: res.data.msg
                })
            }
        })
    }
    /** 获取短信验证码事件*/
    const getSmsCode = () => {
        const mobile = registerForm.getFieldValue("mobile")
        if (!mobile) {
            Toast.show({
                icon:"warning",
                content:"请填写手机号"
            })
            return
        }
        post(`/user/api/ge/send/online/sms/code`, {
            mobile: encode(mobile),
            smsTitle: "医视界"
        }, true).then(res => {
            Toast.show({
                icon:"success",
                content:'发送成功'
            })
        })
    }
    useEffect(() => {
        getRandomImgFn()
    }, [])
    useEffect(() => {

    }, [])
    return (
        <div className={Style.loginHome} >
            <Tabs defaultActiveKey={activeKey}>
                <Tabs.Tab title='登录' key='login'>
                    <Form onFinish={onFinish} >
                        <Form.Item label='手机号' name="mobile" rules={[{ required: true, message: '请输入您的手机号码' }]}>
                            <Input placeholder="请输入手机号"></Input>
                        </Form.Item>
                        <Form.Item label='密码' name="password" rules={[{ required: true, message: '请输入您的密码' }]}>
                            <Input type="password" placeholder="请输入密码" autocomplete="new-password"></Input>
                        </Form.Item>
                        <Form.Item style={{ marginTop: "20px" }}>
                            <Button color='primary' size='large' block type='submit'>登录</Button>
                        </Form.Item>
                    </Form>
                    <h3 style={{textAlign:"center",marginTop:"20px"}}>可使用医学电子书包app账号直接登录</h3>
                </Tabs.Tab>
                <Tabs.Tab title='注册' key='regestery'>
                    <Form form={registerForm} onFinish={registerFinish} >
                        <Form.Item label="手机号" name="mobile" rules={[{ required: true, message: '请输入您的手机号码' }]}>
                            <Input placeholder="请输入手机号"></Input>
                        </Form.Item>
                        <Form.Item
                            label='短信验证码'
                            name="smsCode"
                            rules={[{ required: true, message: '请输入短信验证码' }]}
                            extra={
                                <div >
                                    <Button color="primary" className={Style.smsCode} onClick={getSmsCode}>获取验证码</Button>
                                </div>
                            }

                        >
                            <Input placeholder='请输入短信验证码' />
                        </Form.Item>
                        <Form.Item label="密码" name="password" rules={[{ required: true, pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*?[0-9])[a-zA-Z\d]{8,}$/, message: '不少于8位的字母、数字、大小写组合' }]}>
                            <Input type="password" autoComplete="new-password" placeholder="不少于8位的字母、数字、大小写组合"></Input>
                        </Form.Item>
                        <Form.Item label="确认密码" name="confirmPassword" rules={[{ required: true, pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*?[0-9])[a-zA-Z\d]{8,}$/, message: '再次确认密码' }]}>
                            <Input type="password" autoComplete="new-password" placeholder="再次确认密码"></Input>
                        </Form.Item>
                        <Form.Item style={{ marginTop: "20px" }}>
                            <Button color='primary' size='large' block type='submit'>登录</Button>
                        </Form.Item>
                    </Form>
                </Tabs.Tab>
            </Tabs>
            {/* <Form layout='horizontal' onFinish={onFinish} footer={
                <Button block type='submit' color='primary' size='large'>
                    提交
                </Button>
            }>
                <Form.Item label='姓名' name='name' rules={[{ required: true, message: '请输入姓名' }]}>
                    <Input placeholder="请输入姓名"></Input>
                </Form.Item>
                <Form.Item label='手机号' name='phone' rules={[{ required: true, message: '请输入手机号' }]}>
                    <Input placeholder="请输入手机号"></Input>
                </Form.Item>
            </Form> */}
        </div>
    );
};

export default Index;
